import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import Link from "@airasia/phoenix-components/components/Link"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"

const StyledText = styled.div`
  margin-bottom: 15px;
`

StyledText.displayName = "StyledText"

const LinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`

LinkContainer.displayName = "LinkContainer"

const LinkDiv = styled.div`
  width: 25%;
  margin: 10px 0px;
  color: ${({ theme }) => theme.colors['secondary']};
  & :hover{
    color: ${({ theme }) => theme.colors['primary']};
  }
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`

LinkDiv.displayName = "LinkDiv"

const InternalLinkingBlock = props => {
  const {
    linkObjects,
    blockDescription,
    accessible,
    linkSize,
    linkColor,
    linkHoverColor,
    linkHoverUnderlined,
    linkUnderlined,
    linkTarget,
    blockTitleType,
    descriptionTextColor,
  } = props

  const linkProps = {
    accessible,
    color: linkColor,
    size: linkSize,
    hoverColor: linkHoverColor,
    hoverUnderlined: linkHoverUnderlined,
    target: linkTarget,
    underlined: linkUnderlined,
  }

  const titleProps = {
    accessible,
    type: blockTitleType,
  }

  const [links] = useState(linkObjects)
// console.log("linkObjects",linkObjects)
//   var Pages = props.linkObjects.top_pages || []
//   var Routes = props.linkObjects.top_routes || []
//   var Destination = props.linkObjects.top_destinations || []

  return (
    <div style={{marginLeft:"10px"}}>
        <StyledText>
          <Title {...titleProps}>{links.title}</Title>
        </StyledText>
      {blockDescription && (
        <StyledText>
          <Text accessible color={descriptionTextColor}>
            {blockDescription}
          </Text>
        </StyledText>
      )}
      <LinkContainer>
        {links.top_pages?(
          links.top_pages.map(value => {
          return (
            <LinkDiv key={value.title}>
              <Link href={value.href} {...linkProps}>
                {value.title}
              </Link>
            </LinkDiv>
          )
        })):null}
        {links.top_routes?(
        links.top_routes.map(value => {
          return (
            <LinkDiv key={value.title}>
              <Link href={value.href} {...linkProps}>
                {value.title}
              </Link>
            </LinkDiv>
          )
        })):null}
        {links.top_destinations?(
        links.top_destinations.map(value => {
          return (
            <LinkDiv key={value.title}>
              <Link href={value.href} {...linkProps}>
                {value.title}
              </Link>
            </LinkDiv>
          )
        })):null}
      </LinkContainer>
    </div>
  )
}

InternalLinkingBlock.propTypes = {
  linkObjects: PropTypes.arrayOf(PropTypes.object).isRequired,
  blockTitle: PropTypes.string,
  blockDescription: PropTypes.string,
  accessible: PropTypes.bool,

  linkColor: PropTypes.string,
  linkSize: PropTypes.string,
  linkHoverColor: PropTypes.string,
  linkHoverUnderlined: PropTypes.bool,
  linkUnderlined: PropTypes.bool,
  linkTarget: PropTypes.string,

  blockTitleType: PropTypes.string,

  descriptionTextColor: PropTypes.string,
}

InternalLinkingBlock.defaultProps = {
  accessible: false,

  linkColor: "secondary",
  linkSize: "normal",
  linkHoverColor: "primary",
  linkHoverUnderlined: false,
  linkUnderlined: true,
  linkTarget: "self",

  blockTitleType: "h2",

  descriptionTextColor: "greyDark",
}

export default InternalLinkingBlock
